<template>
    <div>
        <router-view />
    </div>
</template>

<script>
import Header from '@/components/Header';
import Sidebar from '@/components/Sidebar';
export default {
 name: "Index",
}
</script>